export default "__VITE_ASSET__I8USug4N__"